import './App.css';
//importacion de componentes
import Show from './components/show.js';
import Create from './components/create.js';
import Edit from './components/edit.js';
import CreateDate from './components/createDate.js';
import CreateMeds from './components/createMeds.js';
import NavBar from './layout/navbar.js';
import LoginSignIn from './components/login.jsx';
import ShowAdult from './components/showAdult.js';
//imprtacion de el rutador
import { BrowserRouter, Route, Routes } from 'react-router-dom';

function App() {

  return (
    
    <div className="App">

      <BrowserRouter>
        <Routes>
          <Route path='/' element={<LoginSignIn />} />   
          <Route path='/home' element={<NavBar/>}>
            <Route index element={ <Show />} />
            <Route path='/home/create' element={<Create />} />
            <Route path='/home/createDate/:id' element={<CreateDate />} />
            <Route path='/home/edit/:id' element={<Edit />} />         
            <Route path='/home/createMeds/:id' element={<CreateMeds />} />
            <Route path='/home/showAdult/:id' element={<ShowAdult />} />              
          </Route>                                  
        </Routes>
      </BrowserRouter>

    </div>
  );
}
export default App;
